(function () {
    'use strict';

    angular.module('app.core', []);

})();
